






























import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import FilterOptionComponent from '@/components/SideBar/FilterOptionComponent.vue';
import Filter from '@/models/Filter';
import FilterOption from '@/models/FilterOption';
import { FilterAction } from '@/store/actions';
import SearchDefaults from '@/types/SearchDefaults';
import { FilterGetter } from '@/store/getters';
import HelperService from '@/services/HelperService';

@Component({
  name: 'filter-block-component',
  components: { FilterOptionComponent },
})
export default class FilterBlockComponent extends Vue {
  @Prop()
  private filter: Filter | undefined;

  private visibleOptions: Array<FilterOption> = [];

  private isShowMoreVisible = false;

  private helperService = HelperService;

  private get accordionClasses() {
    return {
      'is-active': this.filter ? this.filter.isOpen : true,
    };
  }

  private get translatedFilter(): string {
    return this.filter ? this.helperService.translatedFilter(this.filter) : '';
  }

  private get appliedFilterOptions(): Map<string, FilterOption> {
    return this.$store.getters[FilterGetter.AppliedFilterOptions];
  }

  @Watch('filter.options')
  private updateLocalFilterOptions(): void {
    this.computeVisibleOptions();
  }

  private mounted(): void {
    this.computeVisibleOptions();
  }

  private computeVisibleOptions(): void {
    const options: Array<FilterOption> = this.filter ? [...this.filter?.options.values()] : [];
    this.visibleOptions = [];

    options.forEach((option: FilterOption, index) => {
      if (this.filter?.isExpanded
        || index < SearchDefaults.sidebar.filter.optionsLimit
        || this.appliedFilterOptions.has(option.id)) {
        this.visibleOptions.push(option);
      }
    });

    if (this.filter) {
      this.isShowMoreVisible = this.filter.options.size > SearchDefaults.sidebar.filter.optionsLimit
        && this.filter.options.size >= this.visibleOptions.length;
    }
  }

  private toggleAccordion(): void {
    this.$store.dispatch(FilterAction.ToggleAccordion, { filter: this.filter });
  }

  private async toggleExpanded(): Promise<void> {
    await this.$store.dispatch(FilterAction.ToggleShowMore, { filter: this.filter });
    this.computeVisibleOptions();
  }
}
